jQuery(document).ready(function($) {

  (function($) {
    var defaults = {
      url: false,
      callback: false,
      target: false,
      duration: 120,
      on: 'click',
      touch: true,
      onZoomIn: false,
      onZoomOut: false,
      magnify: 1.4
    };

    $.zoom = function(target, source, img, magnify) {
      var targetHeight, targetWidth, sourceHeight, sourceWidth,
          xRatio, yRatio, offset,
          $target = $(target),
          position = $target.css('position'),
          $source = $(source);

      target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
      target.style.overflow = 'hidden';
      img.style.width = img.style.height = '';

      $(img)
        .addClass('zoomImg engoj_img_main')
        .css({
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          width: img.width * magnify,
          height: img.height * magnify,
          border: 'none',
          maxWidth: 'none',
          maxHeight: 'none',
          cursor: 'zoom-in'
        })
        .appendTo(target);

      return {
        init: function() {
          targetWidth = $target.outerWidth();
          targetHeight = $target.outerHeight();

          if (source === target) {
            sourceWidth = targetWidth;
            sourceHeight = targetHeight;
          } else {
            sourceWidth = $source.outerWidth();
            sourceHeight = $source.outerHeight();
          }

          xRatio = (img.width - targetWidth) / sourceWidth;
          yRatio = (img.height - targetHeight) / sourceHeight;

          offset = $source.offset();
        },
        move: function(e) {
          var pageX = e.pageX || e.clientX;
          var pageY = e.pageY || e.clientY;

          var left = (pageX - offset.left),
              top = (pageY - offset.top);

          top = Math.max(Math.min(top, sourceHeight), 0);
          left = Math.max(Math.min(left, sourceWidth), 0);

          img.style.left = (left * -xRatio) + 'px';
          img.style.top = (top * -yRatio) + 'px';
        }
      };
    };

    $.fn.zoom = function(options) {
      return this.each(function() {
        var settings = $.extend({}, defaults, options || {}),
            target = settings.target && $(settings.target)[0] || this,
            source = this,
            $source = $(source),
            img = document.createElement('img'),
            $img = $(img),
            mousemove = 'mousemove.zoom',
            clicked = false;

        if (!settings.url) {
          var srcElement = source.querySelector('img');
          if (srcElement) {
            settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
          }
          if (!settings.url) return;
        }

        // Handle zoom destroy cleanup
        $source.one('zoom.destroy', function(position, overflow) {
          $source.off(".zoom");
          target.style.position = position;
          target.style.overflow = overflow;
          img.onload = null;
          $img.remove();
        }.bind(this, target.style.position, target.style.overflow));

        img.onload = function() {
          var zoom = $.zoom(target, source, img, settings.magnify);

          function start(e) {
            img.style.setProperty('cursor', 'zoom-out', 'important');
            zoom.init();
            zoom.move(e);
            $img.stop().fadeTo($.support.opacity ? settings.duration : 0, 1,
              $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
          }

          function stop() {
            img.style.setProperty('cursor', 'zoom-in', 'important');
            $img.stop().fadeTo(settings.duration, 0,
              $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
          }

          // Desktop - Click to zoom toggle
          if (settings.on === 'click') {
            $source.on('click.zoom', function(e) {
              if (clicked) {
                return;
              } else {
                clicked = true;
                start(e);
                $(document).on(mousemove, zoom.move);
                $(document).one('click.zoom', function() {
                  stop();
                  clicked = false;
                  $(document).off(mousemove, zoom.move);
                });
                return false;
              }
            });
          }

          // Mobile - Touch toggle (only if enabled)
          if (settings.touch) {
            let touchClicked = false;

            source.addEventListener('touchstart', function(e) {
              e.preventDefault();
              const touch = e.touches[0] || e.changedTouches[0];
              if (touchClicked) {
                stop();
                touchClicked = false;
              } else {
                start(touch);
                touchClicked = true;
              }
            }, { passive: false });

            source.addEventListener('touchmove', function(e) {
              if (touchClicked) {
                e.preventDefault();
                const touch = e.touches[0] || e.changedTouches[0];
                zoom.move(touch);
              }
            }, { passive: false });
          }

          if ($.isFunction(settings.callback)) {
            settings.callback.call(img);
          }
        };

        img.setAttribute('role', 'presentation');
        img.alt = '';
        img.src = settings.url;
      });
    };

    $.fn.zoom.defaults = defaults;

  })(window.jQuery);

  // Track zoom instance initialization state
  let zoomInitialized = false;

  // Function to check screen size and initialize/destroy zoom accordingly
  function handleZoomOnResize() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches || ('ontouchstart' in window);
    
    if (!isMobile && !zoomInitialized) {
      $('.js-zoom-img').zoom();
      zoomInitialized = true;
    } else if (isMobile && zoomInitialized) {
      // Destroy zoom on all zoom elements
      $('.js-zoom-img').each(function() {
        $(this).trigger('zoom.destroy');
      });
      zoomInitialized = false;
    }
  }

  // Initial check
  handleZoomOnResize();

  // Listen for window resize events
  $(window).on('resize', function() {
    handleZoomOnResize();
  });

  // Flickity: Reset zoom when slide changes
  var $carousel = $('.carousel').flickity({
    cellSelector: '.carousel-cell',
    wrapAround: true,
    pageDots: false,
    // ... any other options
  });

  $carousel.on('change.flickity', function(event, index) {
    $('.carousel-cell').each(function(i, slide) {
      if (i !== index && $(slide).find('.zoomImg').length) {
        $(slide).trigger('zoom.destroy');
      }
    });
  });

});
